import React from 'react';
import styled from 'styled-components/macro';

const LanguageBox = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  height: 2rem;
  background-color: white;
  display: flex;
`;

const Language = styled.div<{ isActive: boolean }>`
  display: flex;
  border: 1px solid #8d939d;
  width: 4rem;
  justify-content: center;
  align-items: center;
  border-color: ${({ isActive }) => (isActive ? '#8d939d' : '#eee')};
  cursor: pointer;
  position: relative;
`;

const Text = styled.span<{ isActive: boolean }>`
  position: relative;
  display: flex;
  width: 100%;
  justify-content: center;
`;

const Error = styled.span`
  width: 5px;
  height: 5px;
  background-color: red;
  border-radius: 50%;
  position: absolute;
  top: 2px;
  right: 2px;
`;

export type LocaleTypes = 'en' | 'de' | 'fr' | 'it';

interface Props {
  setLang: (lang: LocaleTypes) => void;
  currentLang: LocaleTypes;
  langErrors: {
    en?: string;
    de?: string;
    fr?: string;
    it?: string;
  };
}

const languages = ['en', 'de', 'fr', 'it'];

const LangSwitcher = ({ setLang, currentLang, langErrors }: Props) => (
  <LanguageBox>
    {languages.map((lang: LocaleTypes) => {
      return (
        <Language
          key={lang}
          isActive={lang === currentLang}
          onClick={() => setLang(lang)}
        >
          <Text isActive={lang === currentLang}>{lang}</Text>
          {langErrors[lang] && <Error />}
        </Language>
      );
    })}
  </LanguageBox>
);

export default LangSwitcher;
